var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyEmogi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_189_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.58065 0 4 3.58065 4 8C4 12.4194 7.58065 16 12 16C16.4194 16 20 12.4194 20 8C20 3.58065 16.4194 0 12 0ZM14.5806 5.41935C15.1516 5.41935 15.6129 5.88064 15.6129 6.45161C15.6129 7.02258 15.1516 7.48387 14.5806 7.48387C14.0097 7.48387 13.5484 7.02258 13.5484 6.45161C13.5484 5.88064 14.0097 5.41935 14.5806 5.41935ZM9.41935 5.41935C9.99032 5.41935 10.4516 5.88064 10.4516 6.45161C10.4516 7.02258 9.99032 7.48387 9.41935 7.48387C8.84839 7.48387 8.3871 7.02258 8.3871 6.45161C8.3871 5.88064 8.84839 5.41935 9.41935 5.41935ZM15.7032 10.9097C14.7839 12.0129 13.4355 12.6452 12 12.6452C10.5645 12.6452 9.21613 12.0129 8.29677 10.9097C7.85806 10.3839 8.65161 9.72581 9.09032 10.2484C9.8129 11.1161 10.871 11.6097 12 11.6097C13.129 11.6097 14.1871 11.1129 14.9097 10.2484C15.3419 9.72581 16.1387 10.3839 15.7032 10.9097Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8953 11.0697L15.8958 11.0691C16.0484 10.8848 16.1026 10.6734 16.0707 10.4719C16.0397 10.2767 15.9313 10.1094 15.7915 9.99348C15.6517 9.87754 15.4674 9.80192 15.2703 9.80741C15.0667 9.81307 14.8692 9.90508 14.717 10.089L14.9097 10.2484L14.7179 10.0881C14.0426 10.8959 13.0547 11.3597 12 11.3597C10.9449 11.3597 9.9573 10.8989 9.28244 10.0884L9.2818 10.0876C9.12812 9.90458 8.93011 9.81304 8.72648 9.8074C8.52904 9.80194 8.34454 9.87739 8.2047 9.99364C8.06487 10.1099 7.95688 10.2776 7.92688 10.4731C7.89594 10.6748 7.95143 10.8859 8.10472 11.0697C9.07151 12.2299 10.4902 12.8952 12 12.8952C13.5098 12.8952 14.9285 12.2299 15.8953 11.0697ZM4.25 8C4.25 3.71872 7.71872 0.25 12 0.25C16.2813 0.25 19.75 3.71872 19.75 8C19.75 12.2813 16.2813 15.75 12 15.75C7.71872 15.75 4.25 12.2813 4.25 8ZM15.8629 6.45161C15.8629 5.74257 15.2897 5.16935 14.5806 5.16935C13.8716 5.16935 13.2984 5.74257 13.2984 6.45161C13.2984 7.16065 13.8716 7.73387 14.5806 7.73387C15.2897 7.73387 15.8629 7.16065 15.8629 6.45161ZM10.7016 6.45161C10.7016 5.74257 10.1284 5.16935 9.41935 5.16935C8.71032 5.16935 8.1371 5.74257 8.1371 6.45161C8.1371 7.16065 8.71032 7.73387 9.41935 7.73387C10.1284 7.73387 10.7016 7.16065 10.7016 6.45161Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_189_4520",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_189_4520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_189_4520",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEmogi);
export default __webpack_public_path__ + "static/media/grey-emogi.6d3cd6526a31597b6e1844764334ed9f.svg";
export { ForwardRef as ReactComponent };